<template>
  <b-modal v-model="modalShow" centered hide-header hide-footer ok-disabled cancel-disabled>
    <div class="text-center modal-container">
      <div class="content">
        <div class="content-subject">{{ $t('selfcheck.checking') }}</div>
        <div class="content-desc">
          <span
            >{{ $t('selfcheck.waitUntilRedirect') }}<br /><br />{{ $t('common.pleaseWait') }}</span
          >
        </div>
        <div class="content-notice">
          <span>{{ $t('selfcheck.howToCancelSelfcheck') }}</span>
        </div>
      </div>
      <div class="buttons">
        <so-button class="button-quit" rounded no-shadow variant="red" @click="handleQuit">
          <img src="@/assets/images/icn_back_to_app.svg" alt />
          <span>{{ $t('selfcheck.smartphoneOrderFinished') }}</span>
        </so-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SoButton from '@/components/common/SoButton'

export default {
  components: {
    SoButton,
  },
  computed: {
    ...mapGetters({
      modalShow: 'modal/isShowingSelfcheckModal',
    }),
    isApp() {
      return process.env.VUE_APP_TYPE === 'app'
    },
  },
  methods: {
    ...mapActions({
      deauth: 'auth/deauth',
      showModal: 'modal/setShowingSelfcheckModal',
    }),
    async handleQuit() {
      await this.deauth()
      this.showModal(false)

      if (this.isApp) {
        this.shutDownApp()
      } else {
        this.navigateToTop()
      }
    },
    shutDownApp() {
      window.location.href = `${process.env.VUE_APP_BASE_CUSTOM_SCHEME}/open/home`
    },
    navigateToTop() {
      if (this.$route.path === '/') return
      this.$router.push({ path: '/' })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .modal {
    top: 0px;
  }
  .modal-dialog {
    margin: 0 !important;
    height: 100%;
    max-width: 100%;
  }
  .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-body {
    height: 100%;
    padding: 0 !important;
  }
}
.modal-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  background: #fff;
  padding-top: 20px;
}
.content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 30px;
  color: #222;

  &-subject {
    font-size: 36px;
    margin-bottom: 18px;
  }
  &-desc {
    font-size: 18px;
    margin-bottom: 24px;
  }
  &-notice {
    font-size: 14px;
    color: #535353;
  }
}
.buttons {
  display: flex;
  justify-content: center;
  padding-bottom: 75px;
}
.button-quit {
  width: 240px;
  height: 40px;

  img {
    width: 18px;
    height: 18px;
    color: #fff;
    margin-right: 8px;
  }
}
.content-desc {
  white-space: pre-wrap;
}
.content-notice {
  white-space: pre-wrap;
}
</style>
